import { render } from "./FilterMenu.vue?vue&type=template&id=3db15874"
import script from "./FilterMenu.vue?vue&type=script&lang=js"
export * from "./FilterMenu.vue?vue&type=script&lang=js"

import "./FilterMenu.vue?vue&type=style&index=0&id=3db15874&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__